import React from "react";
import { TitleBar } from "webapp/components";
import NewWebAppMapClass from "webapp/components/WebAppMap/WebAppMap";
import { useTranslation } from "react-i18next";
import TrxNowGoogleMap from "webapp/components/TrxNowMap/TrxNowGoogleMap";
import { Fragment } from "react";
import LocatingProvider from "webapp/components/LocatingProvider/LocatingProvider";

export default function LocatingProviderContainer(props) {
  const { t } = useTranslation();
  const locatingProviderObj = {
    img: props.logo,
    partner: props.currState.partner,
    fragment: (
      <Fragment>
        <p className="mb-0">
          <strong>{t("description.LocatingProviderTitleBar1")}</strong>
          <br />
          <span style={{ color: "#999" }}>
            {props.isAutoAccept
              ? t("description.LocatingProviderTitleBar2")
              : t("description.AutoAcceptTitleBar2")}
          </span>
        </p>
      </Fragment>
    ),
  };
  return (
    <Fragment>
      {/* <NewWebAppMapClass height={window.innerHeight < 700 ? 150 : 300} disablementCoords={props.startingCoords}/> */}
      <TrxNowGoogleMap
        disablementCoords={props.startingCoords}
        zoom={14}
        width={"100%"}
        height={window.innerHeight < 700 ? 150 : 300}
      />
      <TitleBar data={locatingProviderObj} />
      <LocatingProvider isAutoAccept={props.isAutoAccept} />
    </Fragment>
  );
}
